<template>
  <div class="addClassDialog">
    <div class="btnview">
      <el-button
        class="addclass"
        size="small"
        type="text"
        plain
        @click="openDialog"
        >添加物品</el-button
      >
    </div>

    <el-dialog
      title="选择物品"
      :visible.sync="addClassDialogVisible"
      width="80%"
      top="5vh"
      append-to-body
    >
      <div>
        <p class="search-list">
          <el-input
            size="mini"
            v-model="form.name"
            placeholder="请输入物品名称"
            style="width: 200px; margin-left: 10px"
            @keyup.enter.native="search"
          ></el-input>
        </p>

        <p class="search-list" style="margin-left: 10px">
          <el-button size="mini" type="primary" @click="search">查询</el-button>
        </p>
      </div>

      <div class="dialog-body">
        <el-table
          size="mini"
          ref="classTable"
          :data="goodsList"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          stripe
          :header-cell-style="{ background: '#f5f7fa', color: '#909399' }"
          height="55vh"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column width="50" label="序号">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 + (page_no - 1) * page_size }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="物品名称"> </el-table-column>

          <el-table-column prop="present_price" label="销售单价(单位:元)">
          </el-table-column>

          <el-table-column prop="unit" label="单位"> </el-table-column>
        </el-table>

        <div style="margin-top: 30px; text-align: right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-size="page_size"
            layout="total,prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quit">取消</el-button>
        <el-button size="small" type="primary" @click="confirmTo"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getClassList,
  getCurriculumList,
  getUserTeacher,
  getGoodsList,
} from "@/api/educational";

import { getUserSubjectList } from "@/api/user";
export default {
  name: "addGoods",
  props: {
    campusId: String,
  },
  data() {
    return {
      form: {
        commodity_form: "2",
        name: "",
        page_no: "1",
        page_size: "20",
      },
      goodsList: [],
      addClassDialogVisible: false,
      search_value: "",
      search_type: "1",
      curriculum_id: "",
      lecturer_id: "",
      subject_id: "",
      teacherList: [],
      curriculum_list: [],
      subjectList: [],
      teacher: "",
      tableData: [],
      total: 0,
      page_no: 1,
      page_size: 20,
      chooseGoodList: [],
    };
  },
  methods: {
    //查询所有教具产品
    getGoodsList() {
      getGoodsList({
        commodity_form: "2",
        name: this.form.name,
        page_no: this.form.page_no,
        page_size: this.form.page_size,
      }).then((res) => {
        console.log("商品列表");
        console.log(res);
        this.goodsList = res.goodsList;
        this.total = res.total;
      });
    },

    search() {
      this.form.page_no = 1;
      this.getGoodsList();
    },

    getUserTeacher() {
      getUserTeacher().then((res) => {
        this.teacherList = res.user_list;
      });
    },
    openDialog() {
      if (!this.campusId) {
        console.log("请选择校区ID");
        this.$message.warning("请选择需要交费的学员");
      } else {
        this.getGoodsList();
        this.addClassDialogVisible = true;
      }
    },

    reset() {
      this.search_value = "";
      this.teacher = "";
      this.curriculum_id = "";
      this.subject_id = "";
      this.getClassList();
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.getClassList();
    },
    // 获取学科
    getUserSubjectList() {
      getUserSubjectList().then((res) => {
        this.subjectList = res.base_platform.concat(res.mechanism_platform);
      });
    },
    // 获取课程体系
    getCurriculumList() {
      getCurriculumList({
        subject_id: this.subject_id,
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        this.curriculum_list = res.curriculum_list;
      });
    },
    // 获取班级列表
    getClassList() {
      getClassList({
        search_type: this.search_type,
        search_value: this.search_value,
        subject_id: this.subject_id,
        lecturer_id: this.lecturer_id,
        curriculum_id: this.curriculum_id,
        page_no: this.page_no,
      }).then((res) => {
        this.tableData = res.class_list;
        this.total = res.total;
      });
    },
    handleSelectionChange(selection) {
      this.chooseGoodList = selection;
      console.log("已选物品");
      console.log(selection);
    },
    quit() {
      this.search_value = "";
      this.teacher = "";
      this.curriculum_id = "";
      this.subject_id = "";
      this.addClassDialogVisible = false;
    },
    // 确认导入
    confirmTo() {
      this.$emit("chooseGoodList", this.chooseGoodList);
      this.quit();
    },
  },
};
</script>

<style scoped lang="scss">
.addClassDialog {
  .btnview {
    text-align: left;
    .addclass {
      margin-bottom: 20px;
    }
  }
}

.search-list {
  display: inline-block;
}
.dialog-body {
  margin-top: 20px;
}
</style>